import { Component, Input,Output, OnInit, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DialogService } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { HttpService } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { Project } from '../../project.model';
import { ChangeProjectDialogComponent } from '../change-project-dialog/change-project-dialog.component';

@Component({
  selector: 'app-project-masterdata',
  templateUrl: './project-masterdata.component.html',
  styleUrls: ['./project-masterdata.component.scss']
})
export class ProjectMasterdataComponent implements OnInit {

  @Input() project: Project;

  @Output() projectChanged = new EventEmitter<void>();

  profileForm = new FormGroup({});

  downloadEnabled = true;


  constructor(
    private http: HttpService,
    private dialogService: DialogService,
    public translationService: TranslationService
  ) {

  }

  ngOnInit(): void {
  }


  changeProjectTitle() {
    this.dialogService.openDefault(ChangeProjectDialogComponent, { project: this.project })
    .afterClosed().subscribe(value => {
      this.projectChanged.next();
    });
  }

  exportProject() {
    this.downloadEnabled = false;

    // Trigger opening a new tab. Must be as close as possible to a user action event.
    const newWindow = window.open('', 'project export');

    // keep focus in current window
    window.focus();

    const url = `${environment.erpProjectEndpoint}/exportProjectList`;
    this.http.postWithArraybufferResponse<any>(url, {id: this.project.id}).subscribe(result => {

      const file = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const fileURL = URL.createObjectURL(file);

      // we can open the file in a new tab
      if (newWindow !== null) {
        newWindow.location.href = fileURL;
      } else { // Fallback, if initial opener does not work. But popup blockers will block this.
        window.open(fileURL);
      }
      this.downloadEnabled = true;

    }, error => {
      console.error(error);
      this.downloadEnabled = true;
    });
  }

}
